<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>{{action | translate}}</strong> tipo de operación <span *ngIf="action == 'Delete'"> {{LOCAL_DATA.nombre}}</span></h1>
<div mat-dialog-content fxLayout="column">
  <div fxFlex>
    <mat-form-field *ngIf="action != 'Delete'" fxFlex>
      <input placeholder="Nombre" matInput [(ngModel)]="LOCAL_DATA.nombre" [disabled]="action == 'View'">
    </mat-form-field>
  </div>
    <div fxFlex>
        <mat-form-field *ngIf="action != 'Delete'" class="select-list" fxFlex>
            <mat-label>Tipo de sujeto obligado</mat-label>
            <mat-select
                [(ngModel)]="LOCAL_DATA.tipoSujetoObligado"
                required
                class="roleSelect"
                [disabled]="action == 'View'"
                [compareWith]="compareObjects"
            >
                <mat-option *ngFor="let tipo of tiposSujetos" [value]="tipo">
                    {{ tipo.nombre }} - {{ tipo.nombreC }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div fxFlex>
        <mat-form-field *ngIf="action != 'Delete'" fxFlex>
            <input placeholder="Factor de riesgo" matInput [(ngModel)]="LOCAL_DATA.factorDeRiesgo" [disabled]="action == 'View'" step ="0.1" type="number" min="0.1" max="9.9">
        </mat-form-field>
    </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="doAction()" *ngIf="action != 'View'">{{action | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
